import ConversationLifecycle, { ManagedConversationProps } from './ConversationLifecycle';
import {
  useEffect,
} from 'react';
import {
  useLocation,
} from 'react-router-dom';

import {
  useChatSession,
} from '../hooks/useChatSession';
import {
  useRetziaUser,
} from '../hooks/useRetziaUser';
import {
  navigateWithSession,
  replaceWithSession,
} from '../services/sessionNavigation';
import RetziaActivityWorkspace from './retzia/RetziaActivityWorkspace';
import {
  TASK_REVIEW_FIRST_MESSAGES,
} from './retzia/workspaceConfig';

const FEEDBACK_THRESHOLD = 3;

function TaskReviewSession({initialConversation, requestNew, onPersistenceConflict}: ManagedConversationProps) {
  const location = useLocation();

  const language: string =
    location.state?.language ??
    new URLSearchParams(
      location.search
    ).get('language') ??
    '';

  const {
    currentUser,
    checking,
  } = useRetziaUser();

  const firstMessage =
    TASK_REVIEW_FIRST_MESSAGES[language] ??
    TASK_REVIEW_FIRST_MESSAGES.french;

  const session = useChatSession({
    initialConversation,
    onPersistenceConflict,
    language,
    mode: 'task_review',
    firstMessage,
    messagesLimit: Infinity,
    feedbackThreshold:
      FEEDBACK_THRESHOLD,
  });

  useEffect(() => {
    if (!checking && !currentUser) {
      replaceWithSession(
        `/login?language=${encodeURIComponent(
          language
        )}&returnTo=taskreviewer`
      );
    }
  }, [
    checking,
    currentUser,
    language,
  ]);

  if (checking || !currentUser) {
    return null;
  }

  return (
    <RetziaActivityWorkspace
      language={language}
      session={session}
      newConversationLabel="Nueva actividad"
      onNewConversation={() => void requestNew(session.prepareForNewConversation)}
      newConversationDisabled={!session.isConversationReady || session.isWaitingForBot || session.isMicActivated}
      persistenceError={session.persistenceError}
      reportMode="task_review"
      hideFirstMessage
      inputPlaceholder="Escribe aquí…"
      onClose={() =>
        navigateWithSession('/home')
      }
    />
  );
}

function TaskReview() {
  const location = useLocation();
  const language: string = location.state?.language ?? new URLSearchParams(location.search).get('language') ?? '';
  return <ConversationLifecycle key={language} language={language} mode="task_review">
    {props => <TaskReviewSession {...props} />}
  </ConversationLifecycle>;
}
export default TaskReview;
